<template>
  <div
    class="c-otherInput"
    v-if="hasOtherItem && isOtherItemSelected"
  >
    <c-input-v2
      :name="requestItem.optionJson.other.name"
      :maxlength="requestItem.optionJson.other.max"
      :minlength="requestItem.optionJson.other.min"
      :required="requestItem.requiredFlag"
      immediate-validation
      :placeholder="requestItem.optionJson.other.placeholder"
      v-model="inputValue"
      @input="changeInput"
      @validate="validateInput"
      v-if="requestItem.optionJson.other.displayStyle === 'text'"
    />
    <c-input-v2
      type="textarea"
      :rows="4"
      :name="requestItem.optionJson.other.name"
      :maxlength="requestItem.optionJson.other.max"
      :minlength="requestItem.optionJson.other.min"
      :required="requestItem.requiredFlag"
      immediate-validation
      :placeholder="requestItem.optionJson.other.placeholder"
      v-model="inputValue"
      @input="changeInput"
      @validate="validateInput"
      v-else-if="requestItem.optionJson.other.displayStyle === 'textarea'"
    />
  </div>
</template>
<script>
import { findIndex } from 'lodash-es'

export default {
  name: 'OtherInput',
  props: {
    requestItem: {
      type: Object,
      required: true
    },
    selectedValue: {
      type: Number,
      default: null
    },
    selectedValues: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      inputValue: null,
      isValid: false,
      otherItemValue: null
    }
  },
  watch: {
    isOtherItemSelected() {
      if (this.hasOtherItem) {
        this.$emit('toggle', {
          name: this.requestItem.optionJson.other.name,
          isShow: this.isOtherItemSelected
        })
      }
    }
  },
  mounted() {
    if (!this.hasOtherItem) {
      return
    }

    const otherItemIndex = findIndex(this.requestItem.selectItemsList, 'otherFlag')
    const otherItem = this.requestItem.selectItemsList[otherItemIndex]
    this.otherItemValue = otherItem ? otherItem.value : null
  },
  computed: {
    hasOtherItem() {
      return this.requestItem.optionJson.other ? true : false
    },
    isOtherItemSelected() {
      return (
        this.selectedValue === this.otherItemValue ||
        this.selectedValues.includes(this.otherItemValue)
      )
    }
  },
  methods: {
    changeInput() {
      this.$emit('change', {
        name: this.requestItem.optionJson.other.name,
        value: this.inputValue,
        isValid: this.isValid
      })
    },
    validateInput(isValid) {
      this.isValid = isValid
    }
  }
}
</script>
<style lang="scss" scoped>
.c-otherInput {
  margin-top: 16px;

  /deep/ input {
    padding-left: 12px;
    font-size: 14px;
  }
}

@media (max-width: breakpoint(Requests, M)) {
  .c-otherInput {
    /deep/ input {
      height: 40px;
    }
  }
}

@media (min-width: breakpoint(Requests, M) + 1) {
  .c-otherInput {
    /deep/ input {
      height: 48px;
    }
  }
}
</style>
